export default __webpack_public_path__ + "static/media/carousel50.8cd2e8cd.jpg";